import React from 'react';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { Box, IconButton, Typography } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { useStyles } from '../../styles';
import routes from '../../../../Utils/routes';
import { CURRENCYCODE } from '../../../../Helpers/constant';
import KenColors from '../../../../Helpers/Themes/kenColors';
import Image from '../../../../Assets/assetHelper';
import moment from 'moment';

const EventCards: React.FunctionComponent = (props: any) => {
  const classes = useStyles();
  const navigate = useHistory();
  const location = useLocation();
  const isHomePage = location.pathname === '/home';
  return (
    <div
      className={classes.eventCard}
      style={{
        height: isHomePage ? '85%' : undefined, // Custom height for home page
      }}
      onClick={() => {
        navigate.push(`${routes.eventDetail}/${props?.Id}`, { state: { breadCrumbs: props?.eventTitle || props?.title || props?.name } });
      }}
    >
      <div 
        className={`cardOverlay ${classes.eventCardLayout}`}
        style={{ 
          background: props?.coverImage 
            ? `linear-gradient(rgb(0 0 0) -20%, rgba(0, 0, 0, 0.3) 52%, rgba(0, 0, 0, 0.7) 84%), url(${props?.coverImage})` 
            : `linear-gradient(rgb(0 0 0) -20%, rgba(0, 0, 0, 0.3) 52%, rgba(0, 0, 0, 0.7) 84%), url(${Image.Images.EventCardCoverImage})`
        }}
      >
        <Box component={'div'} className={classes.flexContainer} padding={'10px 10px'}>
          {/* Duration tag moved to top right - hide on home page */}
          {!isHomePage && (
            <Box borderRadius={'100px'} component={'div'} className={classes.cardTag} padding={'4px 10px'}>
              {props?.duration > 0 ? 'Multi Day' : 'One Day'}
            </Box>
          )}
          {props?.fee && (
            <Box borderRadius={'4px'} component={'div'} className={classes.cardTag} padding={'6px 8px'}>
              {CURRENCYCODE[`${props?.CurrencyIsoCode}`]}
            </Box>
          )}
        </Box>
        
        
        {/* Main content moved to bottom */}
        <Box component={'div'} className={classes.eventCardContent} padding={'10px'}>
          <Typography className={classes.cardHeader} fontSize={'16px'}>
            {props?.title}
          </Typography>
          <Box color={KenColors.kenWhite} component={'div'} gap={'2px'} className={classes.flexContainer}>
            <div>
              <div className={classes.cardActionContainer}>
                <AccessTimeOutlinedIcon sx={{ height: '14px' }} />
                <Typography className={classes.description}>
                {moment(props?.startDate).format('DD-MM-YYYY')} - {moment(props?.endDate).format('DD-MM-YYYY')}
                </Typography>
              </div>
              {props?.location ? (
                <div className={classes.cardActionContainer}>
                  <LocationOnOutlinedIcon sx={{ height: '14px' }} />
                  <Typography className={classes.description}>{props?.location}</Typography>
                </div>
              ) : null}
            </div>
            <IconButton
              style={{ padding: '0px' }}
              onClick={() => {
                navigate.push(`${routes.eventDetail}/${props?.Id}`, { state: { breadCrumbs: props?.eventTitle || props?.title || props?.name } });
              }}
            >
              <ArrowForwardOutlinedIcon sx={{ fontSize: '20px', color: KenColors.kenWhite }} />
            </IconButton>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default EventCards;
